"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.hy_list = exports.fxs_public = void 0;
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var webconfig = require('../../config/web');
// 点击-查看最新
$('.icon_new').on('click', function () {
    window.location.reload();
});
// 点击-收藏本页
$('.icon_mark').on('click', function () {
    alert('加入收藏失败，请使用Ctrl+D进行添加');
});
var fxs_public = {
    /**
     * 获取最强分析师收益图的数据
     */
    lineChartData: function (code, page, year) {
        if (year === void 0) { year = ''; }
        var _this = this;
        var sdate = page == 'index' ? year + "-12-31" : '';
        $.ajax({
            url: "" + webconfig.getWebPath('datacenter') + 'api/data/v1/get',
            type: 'GET',
            dataType: 'jsonp',
            data: {
                reportName: 'RPT_RESEARCHER_DETAILS',
                columns: "ALL",
                sortColumns: "TRADE_DATE",
                sortTypes: "-1",
                filter: "(ANALYST_CODE=\"" + code + "\")" + (sdate != '' ? "(TRADE_DATE>='" + sdate + "')" : ""),
                source: "WEB",
                client: "WEB"
            },
            success: function (json) {
                var _a;
                var list = (_a = json === null || json === void 0 ? void 0 : json.result) === null || _a === void 0 ? void 0 : _a.data;
                if (list) {
                    _this.lineChart(list);
                    _this.analystsInfo(list);
                }
            },
            error: function () {
                alert('图表加载失败');
            }
        });
    },
    /**
     * 绘制最强分析师收益图
     */
    lineChart: function (list) {
        var dom = document.getElementById('flashcontent');
        var myChart = echarts.init(dom);
        var dataX = [], dataY = [];
        for (var i = list.length - 1; i >= 0; i--) {
            dataX.push(fieldtools_1["default"].dateformat(list[i].TRADE_DATE));
            dataY.push(fieldtools_1["default"].toFixed(list[i].INDEX_HVALUE, 2));
        }
        var option = {
            grid: {
                bottom: 35,
                top: 10,
                left: 50,
                right: 30,
                show: true,
                borderWidth: 1,
                borderColor: "#ccc"
            },
            tooltip: {
                trigger: 'axis'
            },
            xAxis: {
                type: 'category',
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#efefef',
                        type: 'dashed'
                    }
                },
                // 轴线
                axisLine: {
                    show: false
                },
                // 轴刻度线
                axisTick: {
                    show: false
                },
                data: dataX
            },
            yAxis: {
                type: 'value',
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#efefef',
                        type: 'dashed'
                    }
                },
                // 轴线
                axisLine: {
                    show: false
                },
                // 轴刻度线
                axisTick: {
                    show: false
                }
            },
            series: [{
                    name: '分析师指数',
                    type: 'line',
                    color: 'red',
                    data: dataY,
                    showSymbol: false,
                    lineStyle: {
                        width: 1
                    }
                }]
        };
        myChart.setOption(option, true);
    },
    /**
     * 分析师指数相关信息
     */
    analystsInfo: function (list) {
        if ((list === null || list === void 0 ? void 0 : list.length) > 0) {
            var d = list[0];
            $('#l_name,#l_name1,#l_name2').text(d.ANALYST_NAME);
            $('#l_com').text(d.ORG_NAME);
            $('#l_date').text(fieldtools_1["default"].dateformat(d.UPDATE_DATE));
            $('#l_cszs').text(d.INDEX_PVALUE);
            $('#l_zxzs').text(fieldtools_1["default"].toFixed(d.INDEX_VALUE, 2));
            $('#l_zd').html(fieldtools_1["default"].fieldfmt(d.INDEX_CHANGE, { num: 2, omit: false, showcolor: true }));
            $('#l_zdf').html(fieldtools_1["default"].fieldfmt(d.INDEX_CHANGE_RATE, { num: 2, fix: '%', omit: false, showcolor: true }));
        }
    }
};
exports.fxs_public = fxs_public;
// 行业的列表
function hy_list() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, $.ajax({
                        // url: webconfig.getWebPath("datacenter") + "/api/data/v1/get",
                        url: "https://datacenter-web.eastmoney.com/api/data/v1/get",
                        type: "GET",
                        dataType: "jsonp",
                        data: {
                            columns: "ALL",
                            reportName: "RPT_INDUSTRY_SW2021",
                            sortColumns: "INDUSTRY_CODE",
                            sortTypes: '1',
                            source: "WEB",
                            client: "WEB"
                        },
                        success: function (json) {
                            var _a, _b;
                            var html = '<li class="at2" data="all" data-value>全部</li>';
                            (_b = (_a = json === null || json === void 0 ? void 0 : json.result) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                                html += "<li data=\"" + item.INDUSTRY_CODE + "\" data-value=\"" + item.INDUSTRY_CODE + "\">" + item.INDUSTRY_NAME + "</li>";
                            });
                            $('.st_type').html(html);
                        }
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.hy_list = hy_list;
